package com.cs.ejobin.data.supabase

import com.cs.ejobin.data.SubscriptionRepository
import com.cs.ejobin.model.Subscription
import io.github.jan.supabase.SupabaseClient

class SupabaseSubscriptionRepository(
    private val supabase: SupabaseClient
) : SubscriptionRepository {

    /**
     * ✅ Paiement désactivé : on considère qu'il n'y a pas d'abonnement côté app.
     * On garde la logique côté DB / webhooks / functions pour plus tard.
     */
    override suspend fun getCurrentSubscription(userId: String): Subscription =
        Subscription.None

    /**
     * ✅ Paiement désactivé : ne fait rien.
     * (Ancien flow Stripe Checkout conservé en commentaire)
     */
    override suspend fun startCheckout(userId: String, plan: Subscription.Plan) {
        // Paiement OFF

        // --- Paiement ON (ancien code) ---
        // val response = supabase.functions.invoke(
        //     function = "create-checkout-session",
        //     body = mapOf("plan" to plan.name)
        // )
        //
        // val raw = response.body<String>()
        // if (!response.status.isSuccess()) {
        //     error("Checkout error (${response.status.value}): $raw")
        // }
        //
        // val json = response.body<JsonObject>()
        // val url = json["url"]?.jsonPrimitive?.content ?: error("Missing checkout url: $raw")
        //
        // openUrl(url)
    }

    /**
     * ✅ Paiement désactivé : retour "None".
     */
    override suspend fun refreshSubscription(userId: String): Subscription =
        Subscription.None

    /**
     * ✅ Paiement désactivé : ne fait rien.
     * (Ancienne function cancel-subscription conservée en commentaire)
     */
    override suspend fun cancelAtPeriodEnd(userId: String) {
        // Paiement OFF

        // --- Paiement ON (ancien code) ---
        // supabase.functions.invoke("cancel-subscription")
    }

    // --- Paiement ON (ancien code) ---
    // @OptIn(ExperimentalTime::class)
    // private suspend fun fetch(userId: String): Subscription {
    //     val row = supabase.from("subscriptions")
    //         .select { filter { eq("user_id", userId) } }
    //         .decodeSingleOrNull<SubscriptionRow>() ?: return Subscription.None
    //
    //     val active = row.status == "active" || row.status == "trialing"
    //     if (!active) return Subscription.None
    //
    //     val plan = when (row.plan) {
    //         "MonthlyTrialThen990" -> Subscription.Plan.MonthlyTrialThen990
    //         "Yearly9990" -> Subscription.Plan.Yearly9990
    //         else -> Subscription.Plan.MonthlyTrialThen990
    //     }
    //
    //     val untilMillis = isoToEpochMillis(row.currentPeriodEnd)
    //     return Subscription.Active(plan = plan, validUntilEpochMillis = untilMillis)
    // }
}